const productData = [
  {
    id: 1,
    name: "Luminous Line Necklace",
    category: "Necklaces",
    price: "143.00",
    reviews: "342",
    rating: "4.6",
    image: "/img/101.webp",
    images: ["/img/101.webp", "/img/101a.webp", "/img/101b.webp", "/img/101c.webp", "/img/101d.webp"],
    size: ["One Size"],
    colors: ["Gold", "White Gold"],
    material: "14K Gold Plated, Cubic Zirconia",
    description: [
      "Timeless elegance meets everyday wearability in this classic cubic zirconia line necklace.",
      "Expertly crafted with a continuous line of sparkling cubic zirconia stones that mimic the brilliance of genuine diamonds.",
      "Perfect for adding a touch of sophistication to any outfit, from casual daytime looks to elegant evening ensembles.",
      "Designed to lay beautifully on the neckline, creating a flattering and luminous effect.",
      "A versatile piece that makes a thoughtful gift for birthdays, anniversaries, or any special occasion.",
    ],
    Features: [
      "Continuous line of brilliant cubic zirconia stones",
      "Available in Gold and White Gold finishes",
      "Secure lobster claw clasp for easy wear",
      "14K gold plated base for lasting shine",
      "Hypoallergenic and nickel-free",
      "Perfect layering piece or standalone statement",
    ],
  },
  {
    id: 2,
    name: "Arc Drop Earrings",
    category: "Earrings",
    price: "130.00",
    reviews: "289",
    rating: "4.7",
    image: "/img/102.webp",
    images: ["/img/102.webp", "/img/102a.webp"],
    size: ["One Size"],
    colors: ["Gold"],
    material: "14K Gold Plated, Cubic Zirconia",
    description: [
      "Elevate your look with these refined earrings featuring a softly twisted arc drop design.",
      "Crafted with meticulous attention to detail, these earrings showcase a perfect balance of sophistication and modern style.",
      "The delicate dangling element adds movement and catches the light beautifully with every gesture.",
      "Lightweight and comfortable enough for all-day wear, yet striking enough for special occasions.",
      "A timeless addition to any jewelry collection that will be cherished for years to come.",
    ],
    Features: [
      "Elegant drop design with sparkling cubic zirconia accents",
      "14K gold plated finish for luxurious shine",
      "Post back closure for secure wear",
      "Lightweight construction for comfort",
      "Hypoallergenic materials suitable for sensitive ears",
      "Perfect for both casual and formal occasions",
    ],
  },
  {
    id: 3,
    name: "Facet Hoop Earrings",
    category: "Earrings",
    price: "104.00",
    reviews: "214",
    rating: "4.5",
    image: "/img/103.webp",
    images: ["/img/103.webp"],
    size: ["One Size"],
    colors: ["Gold"],
    material: "14K Gold Plated",
    description: [
      "Classic hoop earrings are reimagined with softly faceted surfaces and a modern oval profile.",
      "The perfect medium-sized hoop that strikes the ideal balance between statement-making and wearable.",
      "Crafted with a smooth, polished finish that reflects light beautifully and adds a radiant touch to any look.",
      "Versatile enough to pair with everything from your favorite jeans to an elegant evening dress.",
      "A wardrobe essential that you'll reach for again and again.",
    ],
    Features: [
      "Perfect medium-sized hoop silhouette",
      "Polished 14K gold plated finish",
      "Hinge closure for easy wear",
      "Lightweight design for all-day comfort",
      "Timeless style that never goes out of fashion",
      "Hypoallergenic and nickel-free",
    ],
  },
  {
    id: 4,
    name: "Whisper Bezel Necklace",
    category: "Necklaces",
    price: "146.00",
    reviews: "178",
    rating: "4.6",
    image: "/img/104.webp",
    images: ["/img/104.webp"],
    size: ["One Size"],
    colors: ["Gold", "Silver"],
    material: "14K Gold Plated or Silver Plated, Cubic Zirconia",
    description: [
      "Delicate and understated, the Whisper Bezel Necklace brings a subtle glow to everyday styling.",
      "Miniature bezel-set cubic zirconia stones are spaced along a fine chain for a light, sparkling effect.",
      "Ideal for layering with other necklaces or wearing alone for a minimalist, sophisticated look.",
      "The fine design makes it perfect for adding a touch of elegance to any outfit without being overpowering.",
      "A beautiful piece that transitions seamlessly from day to night.",
    ],
    Features: [
      "Delicate micro-sized cubic zirconia stones",
      "Available in Gold and Silver finishes",
      "Ultra-fine chain for a delicate look",
      "Perfect for layering with other pieces",
      "Secure clasp closure",
      "Hypoallergenic materials",
    ],
  },
  {
    id: 5,
    name: "Three-Light Huggies",
    category: "Earrings",
    price: "110.00",
    reviews: "305",
    rating: "4.8",
    image: "/img/105.webp",
    images: ["/img/105.webp", "/img/105a.webp"],
    size: ["One Size"],
    colors: ["Gold"],
    material: "14K Gold Plated, Cubic Zirconia",
    description: [
      "The Three-Light Huggies combine a close, comfortable fit with three subtle cubic zirconia accents.",
      "These elegant huggies sit close to the earlobe, providing a comfortable and secure fit.",
      "Perfect for everyday wear, adding a touch of sparkle to your daily look.",
      "The hinged closure makes them easy to put on and take off while ensuring they stay securely in place.",
      "A versatile pair that works beautifully from office meetings to weekend brunch.",
    ],
    Features: [
      "Comfortable huggie design that sits close to the ear",
      "Sparkling cubic zirconia accents",
      "14K gold plated finish",
      "Secure hinged closure",
      "Lightweight and comfortable for all-day wear",
      "Hypoallergenic materials",
    ],
  },
  {
    id: 6,
    name: "Tide Hoop Earrings",
    category: "Earrings",
    price: "125.00",
    reviews: "198",
    rating: "4.4",
    image: "/img/106.webp",
    images: ["/img/106.webp", "/img/106a.webp"],
    size: ["One Size"],
    colors: ["Gold"],
    material: "14K Gold Plated",
    description: [
      "The Tide Hoop Earrings offer a fresh take on the classic silhouette with a gentle wave profile.",
      "Crafted with attention to detail, these hoops feature a substantial yet elegant presence.",
      "Perfect for making a statement while maintaining a sense of refined sophistication.",
      "The polished finish catches the light beautifully, adding a radiant glow to your appearance.",
      "A stunning addition to your jewelry collection that will elevate any ensemble.",
    ],
    Features: [
      "Unique hoop design with modern appeal",
      "Polished 14K gold plated finish",
      "Secure closure mechanism",
      "Comfortable weight for extended wear",
      "Versatile enough for day or evening",
      "Hypoallergenic and nickel-free",
    ],
  },
  {
    id: 7,
    name: "Trio Harmony Bracelet Set",
    category: "Bracelets",
    price: "167.00",
    reviews: "240",
    rating: "4.7",
    image: "/img/107.webp",
    images: ["/img/107.webp"],
    size: ["One Size"],
    colors: ["Gold"],
    material: "14K Gold Plated, Cubic Zirconia",
    description: [
      "The Trio Harmony Bracelet Set is a coordinated collection designed to be worn together or separately.",
      "Each piece in the set features exquisite detailing and sparkling cubic zirconia accents.",
      "Create your own unique look by mixing and matching the different bracelets in the set.",
      "Perfect for adding a touch of glamour to any outfit, from casual to formal.",
      "Makes a beautiful gift for someone special or a wonderful treat for yourself.",
    ],
    Features: [
      "Coordinating bracelet set for versatile styling",
      "Sparkling cubic zirconia details",
      "Polished 14K gold plated finish",
      "Can be worn together or separately",
      "Comfortable fit for all-day wear",
      "Hypoallergenic materials",
    ],
  },
  {
    id: 8,
    name: "Pearl Arc Earrings",
    category: "Earrings",
    price: "146.00",
    reviews: "190",
    rating: "4.8",
    image: "/img/108.webp",
    images: ["/img/108.webp", "/img/108a.webp"],
    size: ["One Size"],
    colors: ["Pearl"],
    material: "14K Gold Plated, Freshwater Pearl, Cubic Zirconia",
    description: [
      "Elegant and timeless, the Pearl Arc Earrings pair softly irregular freshwater pearls with cubic zirconia accents.",
      "The perfect blend of classic sophistication and contemporary design.",
      "These earrings add a touch of romance and refinement to any ensemble.",
      "Ideal for bridal wear, special occasions, or whenever you want to feel extra special.",
      "A truly classic piece that will never go out of style.",
    ],
    Features: [
      "Genuine freshwater pearl centerpiece",
      "Sparkling cubic zirconia accents",
      "14K gold plated setting",
      "Post back closure for secure wear",
      "Perfect for bridal and special occasions",
      "Hypoallergenic materials",
    ],
  },
  {
    id: 9,
    name: "Orbit Pavé Necklace",
    category: "Necklaces",
    price: "130.00",
    reviews: "256",
    rating: "4.7",
    image: "/img/109.webp",
    images: ["/img/109.webp", "/img/109a.webp"],
    size: ["One Size"],
    colors: ["Gold"],
    material: "14K Gold Plated, Cubic Zirconia",
    description: [
      "The Orbit Pavé Necklace showcases an open oval pendant that catches the light from every angle.",
      "A delicate chain supports three offset bezel-set cubic zirconia stones for a refined finish.",
      "Perfect for adding a touch of sparkle to your everyday style or for special occasions.",
      "The elegant design makes it versatile enough to pair with both casual and formal attire.",
      "A beautiful piece that will become a favorite in your jewelry collection.",
    ],
    Features: [
      "Open oval pendant with three cubic zirconia accents",
      "14K gold plated finish",
      "Delicate chain for elegant wear",
      "Perfect length for everyday wear",
      "Secure lobster claw clasp",
      "Hypoallergenic and nickel-free",
    ],
  },
  {
    id: 10,
    name: "Threefold Ring Set",
    category: "Rings",
    price: "146.00",
    reviews: "312",
    rating: "4.9",
    image: "/img/1010.webp",
    images: ["/img/1010.webp", "/img/1010a.webp"],
    size: ["5", "6", "7", "8", "9", "10"],
    colors: ["Gold"],
    material: "14K Gold Plated, Cubic Zirconia",
    description: [
      "The Threefold Ring Set features coordinating bands designed to be stacked or worn individually.",
      "Each ring in the set offers unique detailing and sparkling cubic zirconia accents.",
      "Create endless styling combinations by mixing and matching the different rings.",
      "Perfect for adding a touch of glamour to your fingers and expressing your personal style.",
      "A versatile set that works beautifully for both everyday and special occasions.",
    ],
    Features: [
      "Coordinating ring set for stacking",
      "Sparkling cubic zirconia details",
      "14K gold plated finish",
      "Available in multiple sizes",
      "Can be worn together or separately",
      "Hypoallergenic materials",
    ],
  },
  {
    id: 11,
    name: "Twin Arc Ear Cuff",
    category: "Earrings",
    price: "72.00",
    reviews: "198",
    rating: "4.6",
    image: "/img/1011.webp",
    images: ["/img/1011.webp", "/img/1011a.webp"],
    size: ["One Size"],
    colors: ["Gold"],
    material: "14K Gold Plated, Cubic Zirconia",
    description: [
      "Add an understated edge to your look with the polished-and-pavé Twin Arc Ear Cuff.",
      "Featuring a stunning pave design that sparkles beautifully in the light.",
      "No piercing required - simply cuff it to your ear for an instant style upgrade.",
      "Perfect for creating a modern, layered ear look without the commitment of additional piercings.",
      "Comfortable enough to wear all day and eye-catching enough for special occasions.",
    ],
    Features: [
      "Stunning pave design with cubic zirconia",
      "No piercing required",
      "Hinge mechanism for secure fit",
      "14K gold plated finish",
      "Comfortable for extended wear",
      "Hypoallergenic materials",
    ],
  },
  {
    id: 12,
    name: "Starpoint Huggies",
    category: "Earrings",
    price: "98.00",
    reviews: "267",
    rating: "4.5",
    image: "/img/1012.webp",
    images: ["/img/1012.webp"],
    size: ["One Size"],
    colors: ["Gold"],
    material: "14K Gold Plated, Cubic Zirconia",
    description: [
      "The Starpoint Huggies feature a modern asymmetric design with subtle cubic zirconia accents.",
      "These stylish huggies sit comfortably close to the ear, perfect for everyday wear.",
      "Add a touch of celestial-inspired glamour to your look with these beautiful earrings.",
      "The secure hinged closure ensures they stay in place comfortably all day long.",
      "A versatile pair that transitions effortlessly from day to night.",
    ],
    Features: [
      "Modern design with cubic zirconia accents",
      "Comfortable huggie fit",
      "14K gold plated finish",
      "Secure hinged closure",
      "Lightweight and comfortable",
      "Hypoallergenic and nickel-free",
    ],
  },
  {
    id: 13,
    name: "Green Baguette Huggies",
    category: "Earrings",
    price: "104.00",
    reviews: "223",
    rating: "4.6",
    image: "/img/1013.webp",
    images: ["/img/1013.webp"],
    size: ["One Size"],
    colors: ["Gold"],
    material: "14K Gold Plated, Cubic Zirconia",
    description: [
      "Elegant and graphic, the Green Baguette Huggies feature baguette-cut green cubic zirconia.",
      "The unique baguette cut adds a touch of Art Deco glamour to these contemporary huggies.",
      "Perfect for adding a touch of color and sparkle to your everyday ensemble.",
      "Comfortable enough for all-day wear, yet elegant enough for special occasions.",
      "A timeless design that will elevate any jewelry collection.",
    ],
    Features: [
      "Beautiful baguette-cut cubic zirconia stones",
      "Elegant huggie design",
      "14K gold plated finish",
      "Secure hinged closure",
      "Comfortable for extended wear",
      "Hypoallergenic materials",
    ],
  },
  {
    id: 14,
    name: "Parallel Arc Earrings",
    category: "Earrings",
    price: "125.00",
    reviews: "198",
    rating: "4.7",
    image: "/img/1014.webp",
    images: ["/img/1014.webp", "/img/1014a.webp"],
    size: ["One Size"],
    colors: ["Gold", "White Gold"],
    material: "14K Gold Plated or White Gold Plated, Cubic Zirconia",
    description: [
      "The Parallel Arc Earrings pair one polished curve with one sparkling cubic zirconia curve.",
      "Perfect for adding a touch of sophistication and glamour to any look.",
      "The unique double-huggie design creates a modern and stylish appearance.",
      "Comfortable and secure, these earrings are perfect for everyday wear or special occasions.",
      "Available in both Gold and White Gold finishes to suit your personal style.",
    ],
    Features: [
      "Elegant double design with cubic zirconia",
      "Available in Gold and White Gold finishes",
      "Comfortable huggie fit",
      "Secure hinged closure",
      "Versatile for day or evening wear",
      "Hypoallergenic materials",
    ],
  },
  {
    id: 15,
    name: "Halo Drop Lariat Necklace",
    category: "Necklaces",
    price: "203.00",
    reviews: "312",
    rating: "4.8",
    image: "/img/1015.webp",
    images: ["/img/1015.webp", "/img/1015a.webp"],
    size: ["One Size"],
    colors: ["Gold"],
    material: "14K Gold Plated, Cubic Zirconia",
    description: [
      "The Halo Drop Lariat Necklace features an elegant open-circle slider and cubic zirconia tips.",
      "Perfect for adding a touch of romance and sophistication to any neckline.",
      "The adjustable lariat design allows you to customize the look to suit your outfit.",
      "Ideal for both formal occasions and everyday elegance.",
      "A truly stunning piece that will become a cherished favorite.",
    ],
    Features: [
      "Elegant lariat design with sparkling cubic zirconia",
      "14K gold plated finish",
      "Adjustable length for versatile styling",
      "Perfect for dressing up any outfit",
      "Secure yet adjustable design",
      "Hypoallergenic and nickel-free",
    ],
  },
  {
    id: 16,
    name: "Luminous Line Bracelet",
    category: "Bracelets",
    price: "146.00",
    reviews: "187",
    rating: "4.7",
    image: "/img/1016.webp",
    images: ["/img/1016.webp", "/img/1016a.webp"],
    size: ["One Size"],
    colors: ["Gold", "White Gold"],
    material: "14K Gold Plated or White Gold Plated, Cubic Zirconia",
    description: [
      "A timeless classic, the Luminous Line Bracelet features a continuous line of sparkling cubic zirconia.",
      "Perfect for adding a touch of elegance to your wrist, whether for everyday or special occasions.",
      "The classic design makes it versatile enough to pair with any outfit, from casual to formal.",
      "A beautiful piece that makes a perfect gift for birthdays, anniversaries, or any special occasion.",
      "Available in both Gold and White Gold finishes to complement your personal style.",
    ],
    Features: [
      "Continuous line of brilliant cubic zirconia stones",
      "Available in Gold and White Gold finishes",
      "Secure clasp for peace of mind",
      "14K gold plated for lasting shine",
      "Classic design that never goes out of style",
      "Hypoallergenic materials",
    ],
  },
  {
    id: 17,
    name: "Soft-Square Pavé Hoops",
    category: "Earrings",
    price: "167.00",
    reviews: "234",
    rating: "4.6",
    image: "/img/1017.webp",
    images: ["/img/1017.webp", "/img/1017a.webp"],
    size: ["One Size"],
    colors: ["Gold"],
    material: "14K Gold Plated, Cubic Zirconia",
    description: [
      "The Soft-Square Pavé Hoops feature front-facing stone details that sparkle from every angle.",
      "These eye-catching hoops combine classic hoop style with glamorous pave design.",
      "Perfect for making a statement while maintaining timeless elegance.",
      "The substantial yet comfortable design makes them ideal for special occasions.",
      "A truly glamorous addition to any jewelry collection.",
    ],
    Features: [
      "Stunning pave design with cubic zirconia",
      "14K gold plated finish",
      "Comfortable hoop silhouette",
      "Secure closure mechanism",
      "Perfect for special occasions",
      "Hypoallergenic and nickel-free",
    ],
  },
  {
    id: 18,
    name: "Six-Prong Stud Earrings",
    category: "Earrings",
    price: "120.00",
    reviews: "201",
    rating: "4.6",
    image: "/img/1018.webp",
    images: ["/img/1018.webp", "/img/1018a.webp"],
    size: ["3mm", "5mm", "7mm", "9mm"],
    colors: ["Gold", "Silver"],
    material: "14K Gold Plated or Silver Plated, Cubic Zirconia",
    description: [
      "Classic and versatile, the Six-Prong Stud Earrings feature brilliant round cubic zirconia stones.",
      "Perfect for everyday wear, these studs add just the right amount of sparkle to any look.",
      "Available in multiple sizes to suit your preference, from delicate to more substantial.",
      "A timeless essential that belongs in every jewelry collection.",
      "Comfortable enough to wear all day and elegant enough for special occasions.",
    ],
    Features: [
      "Brilliant cubic zirconia stone",
      "Available in multiple sizes (3mm, 5mm, 7mm, 9mm)",
      "Available in Gold and Silver finishes",
      "Secure post back closure",
      "Classic and versatile design",
      "Hypoallergenic materials suitable for sensitive ears",
    ],
  },
  {
    id: 19,
    name: "Ribbon Petal Earrings",
    category: "Earrings",
    price: "243.00",
    reviews: "276",
    rating: "4.8",
    image: "/img/1019.webp",
    images: ["/img/1019.webp", "/img/1019a.webp"],
    size: ["One Size"],
    colors: ["Silver"],
    material: "Silver Plated, Cubic Zirconia",
    description: [
      "The Ribbon Petal Earrings use airy silver curves to create an original five-petal floral silhouette.",
      "Perfect for adding a romantic and whimsical touch to your look.",
      "The detailed craftsmanship and sparkling stones create a truly stunning effect.",
      "Ideal for special occasions, weddings, or whenever you want to feel truly special.",
      "A unique and memorable piece that will be admired by all who see it.",
    ],
    Features: [
      "Exquisite floral design with cubic zirconia",
      "Silver plated finish",
      "Intricate detailing",
      "Perfect for special occasions",
      "Comfortable and secure wear",
      "Hypoallergenic materials",
    ],
  },
  {
    id: 20,
    name: "Essential Oval Hoops",
    category: "Earrings",
    price: "115.00",
    reviews: "189",
    rating: "4.6",
    image: "/img/1020.webp",
    images: ["/img/1020.webp", "/img/1020a.webp"],
    size: ["One Size"],
    colors: ["Gold"],
    material: "14K Gold Plated",
    description: [
      "The Essential Oval Hoops offer a clean, slender design made for repeat wear.",
      "The perfect hoop silhouette that complements any face shape and style.",
      "Crafted with quality materials and a beautiful polished finish.",
      "Versatile enough to pair with everything in your wardrobe, from casual to formal.",
      "An essential piece that you'll reach for time and time again.",
    ],
    Features: [
      "Classic timeless hoop design",
      "Polished 14K gold plated finish",
      "Comfortable and lightweight",
      "Secure closure",
      "Versatile for any occasion",
      "Hypoallergenic and nickel-free",
    ],
  },
];

export default productData;
